import axios from 'axios';
import { createConcurrencyLimiter } from './createConcurrencyLimiter';

const TRACK_LENGTH_FETCH_CONCURRENCY = 4;
const limitedFetch = createConcurrencyLimiter(TRACK_LENGTH_FETCH_CONCURRENCY);

const lengthCache = new Map();
const inflightRequests = new Map();

export function getCachedTrackLength(episodeId) {
  return lengthCache.get(episodeId);
}

export function fetchTrackLength(episode, token) {
  const episodeId = episode.id;
  const trackId = episode.playlist_media?.id;
  if (!trackId) return Promise.resolve(null);
  if (lengthCache.has(episodeId)) return Promise.resolve(lengthCache.get(episodeId));
  if (inflightRequests.has(episodeId)) return inflightRequests.get(episodeId);

  const promise = limitedFetch(() =>
    axios.get(`https://broadcast.wssr.stream/api/station/1/file/${trackId}`, {
      headers: { Authorization: token },
    })
  )
    .then((response) => {
      const lengthText = response.data.length_text;
      lengthCache.set(episodeId, lengthText);
      return lengthText;
    })
    .catch((error) => {
      console.error('Error fetching track length:', error);
      return null;
    })
    .finally(() => {
      inflightRequests.delete(episodeId);
    });

  inflightRequests.set(episodeId, promise);
  return promise;
}
